import { Table } from "antd";
import { NotFound } from "../../../../sources/svg/svg";
import { Link } from "react-router-dom";
import { _adr } from "../../../../address";
import { convertToJalaliWithoutTime, convertToJalaliWithTime } from "../../../../tools/tools";
import { useDealer } from "../../../../tools/api";

import styles from "./tables.module.scss";
import { useState } from "react";

const TablesPurchase = ({ resultSearch = [], callback }) => {
  const { queryFirstActivationDate } = useDealer();
  const handleCallBack = (sppurchaseid) => {
    callback(sppurchaseid);
  };

  const [firstDate, setFirstDate] = useState();

  const handleFirstUsage = async (msisdn) => {
    const response = await queryFirstActivationDate(msisdn);
    if (response) {
      let item = response?.split(" ")[0].split("/").reverse();
      item = item[0] + "-" + item[2] + "-" + item[1] + "T" + response?.split(" ")[1];
      setFirstDate(item);
    }
  };

  return (
    <>
      <div className="holder-table" style={{ marginTop: "3rem" }}>
        <Table
          className="tbl-normal"
          columns={[
            {
              title: "شماره",
              dataIndex: "msisdn",
              key: "msisdn",
              width: 150,
            },
            {
              title: "تاریخ فعال‌سازی",
              dataIndex: "countersim",
              key: "countersim",
              width: 150,
            },
            {
              title: "تاریخ اولین استفاده",
              dataIndex: "firstusage",
              key: "firstusage",
              width: 150,
            },
            {
              title: "شماره کیت",
              dataIndex: "kit",
              key: "kit",
              width: 150,
            },
            {
              title: "شماره ملی",
              dataIndex: "certno",
              key: "certno",
              width: 150,
            },
            {
              title: "وضعیت خرید",
              dataIndex: "purchasestatus",
              key: "purchasestatus",
              width: 150,
            },
            {
              title: "نوع مشترک",
              dataIndex: "profiletype",
              key: "profiletype",
              width: 150,
            },
            {
              title: "نام کاربر",
              dataIndex: "username",
              key: "username",
              width: 150,
            },
          ]}
          locale={{
            emptyText: (
              <>
                <NotFound text={"رکوردی یافت نشد."} />
              </>
            ),
          }}
          pagination={{
            showSizeChanger: false,
          }}
          dataSource={resultSearch.map((item, key) => ({
            key: key,
            msisdn: <Link onClick={(e) => handleCallBack(item?.purchaseProductId)}>{item?.msisdn}</Link>,
            countersim: convertToJalaliWithTime(item?.purchaseDate),
            firstusage: (
              <>
                {firstDate ? (
                  <>{convertToJalaliWithoutTime(firstDate)}</>
                ) : (
                  <i onClick={() => handleFirstUsage(item?.msisdn)} className={`icon-reload ${styles.reload}`}></i>
                )}
              </>
            ),
            kit: item?.iccid?.slice(10, 19),
            certno: item.certNo,
            purchasestatus: item?.purchaseStateString,
            profiletype: item?.profileTypeString,
            username: item?.userName,
          }))}
        />
      </div>
    </>
  );
};

export default TablesPurchase;
